export default {
  LANG_CODE: 'fr',
  LANG_NOT_FOUND: 'Actuellement Nous ne prenons pas en charge la langue que vous essayez de sélectionner.',
  LANG_HAS_DELETED: 'Nous ne prenons pas en charge la langue sélectionnée, veuillez contacter notre équipe d’assistance.',
  USER_ID: 'ID de l’utilisateur',
  USER_NAME: 'Nom d’utilisateur',
  PASSWORD: 'Mot de passe',
  REQUIRED_FIELD: 'est un champ obligatoire',
  FORGOT_PASSWORD: 'Mot de passe oublié',
  API_DEFAULT_ERROR: 'Un problème s’est produit, veuillez réessayer après un certain temps.',
  SUPPORT_LABEL: 'Pour les problèmes de connexion ou de mot de passe, contactez',
  BACK_TO_LOGIN: 'Retour à la connexion',
  SUBMIT: 'Envoyer',
  YES: 'Oui',
  NO: 'Non',
  DELETE: 'Supprimer',
  LOGOUT: 'Déconnexion',
  LOGOUT_POPUP_TITLE: 'Voulez-vous vous déconnecter?',
  EVENT_INFO: 'Informations sur l’événement',
  QUALIFYING_QUESTIONS: 'Questions de qualification',
  CONTENT: 'Contenu',
  EMAILS: 'E-mails',
  PREVIOUS: 'Précédent',
  CONTINUE: 'Continuer',
  FINISH: 'Terminer',
  ADD: 'Ajouter',
  CANCEL: 'Annuler',
  APPROVE: 'Approuver',
  INVALID_FIELD: 'Le champ n’est pas valide',
  SET: 'Définir',
  EXHIBITORS: 'Exposants',
  EVENT_ID: 'Id de l’événement',
  PASS_MIN_LEN_ERROR: 'doit contenir au moins 6 caractères.',
  SAVE: 'Sauvegarder',
  EDIT: 'Modifier',
  COOCKIE_POLICY: 'Politique en matière de cookies',
  COOCKIE_TEXT:
    'Les cookies nous aident à fournir nos services. Nous utilisons des cookies techniques pour vous offrir la meilleure expérience de notre site. En fermant cette fenêtre ou en continuant à utiliser le site, vous acceptez que nous utilisions ces cookies. Pour en savoir plus, consultez nos',
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: 'Succès!',
  FAILED_TITLE: 'Échec!',
  OR: 'Ou',
  EVENT_SETTINGS: "Paramètres d'événement",
  LEADS: 'Conduit',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: 'Souhaitez-vous supprimer ce'
}
